import { MouseEvent } from 'react';
import type { TranslationsType } from '@/modules/common/data/translations';
import { VariantType } from '@/modules/models/VariantType';
import { PageType } from './Page';

export type SemiOpenConfig = {
  delay: number;
  pageTypes?: PageType[];
};

type abTestConfig = {
  uuid: string; // A/B Test uuid
  group: string; // user test group
  groupsList: string[]; // groups names list
  testEndDate: string;
};

export type tooltipConfig = {
  duration: number;
  delay?: number;
  pauseOnHover?: boolean;
};

type initTooltipConfig = tooltipConfig & {
  closeBtn?: boolean;
};

export type productsTooltipConfig = tooltipConfig & {
  products: number;
};

// TODO: clean up BridgeType unused properties
export type BridgeType = {
  apiKey: string;
  apiUrl: string;
  pageType: PageType;
  productId: string;
  variantId?: string;
  countryCode?: string; // selected country for price calculation
  localization?: string; // first answer language from ML
  location?: string; // user location (use ipinfo api)
  closeChatWithEsc: boolean;
  projectName: string;
  translations: TranslationsType; // translations for the current project (Shopify app)
  isAlwaysOpenWSConnection: boolean;
  isSupportSubDomainWithCookie?: boolean;
  onInit?: () => void;
  onToggleTooltip?: (state: boolean) => void;
  onToggleChat?: (state: boolean) => void;
  onProactiveOpen?: () => void;
  onAddToCart?: (productId?: string) => void;
  onResetChat?: () => void;
  onMessageReady?: () => void;
  onWSSubscribed?: () => void;
  onSessionStart?: () => void;
  onClickTooltip?: () => void;
  onAddToCartFromChat?: (product: any, event: MouseEvent<HTMLButtonElement>) => void;
  onSentSuggestion?: (messageId: number) => void;
  onGetSuggestion?: ({ replyMessageId, content }: { replyMessageId: number; content: string }) => void;
  onChangeTestGroup?: (testGroupName: string) => void;
  onClickPopupCloseBtn?: () => void;
  semiOpenConfig?: SemiOpenConfig;
  widgetExclusions?: string[];
  widgetWhitelist?: string[];
  initPopupExclusions?: Partial<Record<string, boolean>>;
  handleIframeMouseEvents?: boolean;
  autofocusInput?: boolean;
  isUploadBtnActive?: boolean;
  abTestConfig?: {
    client: abTestConfig;
    ml: abTestConfig;
  };
  shopifyAddToCartParams?: {};
  isEmbedded?: boolean;
  isLiveAgentEnabled?: boolean;
  prompts?: {
    iconUrl?: string;
    iconSvg?: string;
    caption: string;
    prompt?: string;
    translationId: string;
    id?: number;
  }[];
  crossSaleMessage?: boolean;
  widget?: {
    initTooltip: boolean | initTooltipConfig;
    stuckTooltip: boolean | tooltipConfig;
    productsTooltip: boolean | productsTooltipConfig;
    crossSaleTooltip: boolean | tooltipConfig;
    isPopupClosable?: boolean;
  };
  defaultTooltipBehavior?: boolean;
  productCard?: {
    relativeLinks?: boolean;
    disabled?: boolean;
    hideAddToCartButton?: boolean;
    hideVariants?: boolean;
    hideCheckItOut?: boolean;
    variantsConfig?: {
      [k in VariantType]: {
        optionNames: string[];
        replaceName: string;
        colorsMap?: Record<string, string>;
      };
    };
  };
  shouldFetchTranslations?: boolean;
  isTestModeAvailable?: boolean;
};
